import { Text, Button } from '@/components'
import { Link } from '@/app/components'
import { AlertMessage } from 'app-components'
import { ButtonContainer } from '@/app/pages/ava/BrandedPage'

interface ConnectionApiFailureViewProps {
  onConfirmClick: () => void
  isLoading: boolean
}

export default function ConnectionApiFailureView({
  onConfirmClick,
  isLoading,
}: ConnectionApiFailureViewProps) {
  return (
    <>
      <Text variant="h2" className="!mt-16">
        Connection Test Failed
      </Text>
      <div className="flex flex-col gap-3 !mt-4">
        <AlertMessage show={true} variant="error">
          Oh no! Something went wrong. You can retry the connection test or
          contact support if it doesn't work.
        </AlertMessage>
        <div className="flex flex-col">
          <Link href="mailto:support@optiwatt.com" className="!no-underline">
            Need Support?
          </Link>
          <Link href="mailto:support@optiwatt.com" className="!no-underline">
            Email support@optiwatt.com
          </Link>
        </div>
      </div>
      <ButtonContainer>
        <Button
          id="tesla-fleet-auth-survey-retry-button"
          variant="primary"
          disabled={isLoading}
          onClick={onConfirmClick}
        >
          Retry Connection Test
        </Button>
      </ButtonContainer>
    </>
  )
}
